import React from 'react';

const About = () => {
  return (
    <section id="about" data-aos="fade-up" className="py-20">
      <div className="container mx-auto px-4 text-center animate-fade-in">
        <h2 className="text-3xl font-bold mb-8">Sobre Nós</h2>
        <div className="text-lg text-gray-600 max-w-4xl mx-auto space-y-4">
          <p>
            Somos a Olimars, uma empresa líder em soluções de nuvem e desenvolvimento de software. Com anos de experiência no mercado, dedicamo-nos a fornecer ferramentas inovadoras que transformam a maneira como as empresas operam.
          </p>
          <p>
            Nossa linha de produtos Unisales inclui o Unisales-CRM para gestão eficiente de clientes, o Unisales-Eventos para organização perfeita de eventos, e o Unisales-ERP para integração completa de processos empresariais. Cada solução é projetada para maximizar a produtividade e impulsionar o crescimento dos nossos clientes.
          </p>
          <p>
            Na Olimars, acreditamos na combinação de tecnologia avançada com atendimento personalizado. Nossa equipe de especialistas trabalha lado a lado com você para implementar soluções que se adaptam às suas necessidades específicas, garantindo resultados excepcionais.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
